import { render } from "./UserForm.vue?vue&type=template&id=2be22cc1"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=2be22cc1&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__